import { getKolVisitContext } from "../../attribution/kolVisit";
import type {
  KolTrafficType,
  KolVisitContext,
} from "../../attribution/kolVisit";
import type { AttributionStorageTarget } from "../../attribution/storage";

export interface HallAcquisitionContext extends KolVisitContext {
  appSurface: "hall";
  trackingVersion: "kol-v1";
  acquisitionSource: "kol" | "other";
  trafficType: KolTrafficType;
}

const isLocalHost = (hostname: string): boolean => {
  return (
    hostname === "localhost" ||
    hostname.endsWith(".localhost") ||
    hostname === "[::1]" ||
    /^127\.\d+\.\d+\.\d+$/.test(hostname)
  );
};

export const getHallAcquisitionContext = (
  target?: AttributionStorageTarget,
  buildMode = process.env.NODE_ENV,
  nowMs = Date.now(),
): HallAcquisitionContext => {
  const win = target ?? (typeof window === "undefined" ? undefined : window);
  const visit = getKolVisitContext(win, nowMs);
  const hostname = win ? new URL(win.location.href).hostname : "";
  const trafficType =
    visit.trafficType ??
    (buildMode === "production" && !isLocalHost(hostname) ? "production" : "test");

  return {
    ...visit,
    ...(visit.landingPageId ? { entryKind: visit.entryKind || "browser" } : {}),
    appSurface: "hall",
    trackingVersion: "kol-v1",
    acquisitionSource: visit.landingPageId ? "kol" : "other",
    trafficType,
  };
};
